import {createContext, type PropsWithChildren, use, useMemo} from 'react'

export type ButtonContext = {
  onClick: () => void
  buttonRef: React.RefObject<HTMLButtonElement | null>
}

export const ButtonContext = createContext<ButtonContext | undefined>(undefined)

type ButtonProviderProps = ButtonContext

export function ButtonProvider({children, onClick, buttonRef}: PropsWithChildren<ButtonProviderProps>) {
  const value = useMemo(
    () => ({
      onClick,
      buttonRef,
    }),
    [onClick, buttonRef],
  )

  return <ButtonContext value={value}>{children}</ButtonContext>
}

export function useButton() {
  const context = use(ButtonContext)
  if (!context) {
    throw new Error('useButton must be used within a ButtonProvider')
  }
  return context
}
